export interface AuthConfig {
  strategy: 'none' | 'bearerAuth' | 'basicAuth' | 'apiKeyAuth'; // Tipo di autenticazione
  token?: string; // Token statico per Bearer o ApiKey
  username?: string; // Username per Basic Auth
  password?: string; // Password per Basic Auth
}

export interface ServiceRegistry {
  importPath: string,
  authConfig: AuthConfig; // Configurazione per l'autenticazione a livello di servizio
  methods: {
    [methodName: string]: {
      clientMethod: string;
      params: string[] | never[];
      timeout?: number; // Timeout specifico per questo metodo. Se non specificato, si usa default 10000
      authConfig?: AuthConfig;
    };
  };
}

export const registry: Record<string, ServiceRegistry> = {
  ServiceModel: {
    importPath: "Api/Services/", 
    authConfig: { strategy: "bearerAuth" }, // Usa il token dell'utente autenticato
    methods: {
      getTools: {
        clientMethod: "getToolsUsingGET",
        params: [],
      },
      getToolById: {
        clientMethod: "getToolByIdUsingGET",
        params: ["toolId"],
      },
      findCrops: {
        clientMethod: "findCrops",
        params: [],
      }, 
      getStations: {
        clientMethod: "getNearestStations",
        params: ["request"],
      }, 
    },
  },
  UserService: {
    importPath: "Api/Services/",
    authConfig: { strategy: "bearerAuth" }, // Usa il token dell'utente autenticato
    methods: {
      registerUser: {
        clientMethod: "registerUser",
        params: ["request"],
        authConfig: { strategy: "none" },
      },
      getUserMe: {
        clientMethod: "findMe",
        params: []
      },
      savePersonalData: {
        clientMethod: "saveMePersonalData",
        params: ["personData"]
      },
      changePassword: {
        clientMethod: "updateMyPassword",
        params: ["newPasswordRequest"]
      }, 
      updateUserProfiles: {
        clientMethod: "saveMyProfiles",
        params: ["profiles"]
      }, 
      saveFarm: {
        clientMethod: "saveMyFarm",
        params: ["request"]
      }, 
      saveRoi: {
        clientMethod: "uploadRoi",
        params: ["name","description","type","uploadedFile"]
      },
      saveParcel: {
        clientMethod: "saveMyParcel",
        params: ["userParcelRequest"]
      },
      saveParcelOperation: {
        clientMethod: "saveMyParcelOperation",
        params: ["userParcelOperationRequest"]
      },
      updateParcelOperationStatus: {
        clientMethod: "updateStatusOnMyParcelOperation",
        params: ["id","updateParcelOperationStatusRequest"]
      },
      getMyMetadata: {
        clientMethod: "findMyMetaData",
        params: []
      },
      createOrUpdateParcelFromGeoJson: {
        clientMethod: "createOrUpdateParcelFromGeoJson",
        params: ["request"]
      },
    },
  },
  ExternalService: {  //esempio di una api con apikey
    importPath: "Api/Services/",
    authConfig: { strategy: "apiKeyAuth", token: "12345-abcde-key" }, // Configurazione per API key statica
    methods: {
      fetchData: {
        clientMethod: "fetchDataUsingGET",
        params: [],
      },
    },
  },
  OtherService: {  //esempio di una api con bearer assegnato dal fornitore del servizio
    importPath: "Api/Services/",
    authConfig: { strategy: "bearerAuth", token: "12345-abcde-key" }, 
    methods: {
      fetchData: {
        clientMethod: "fetchDataUsingGET",
        params: [],
      },
    },
  },
  OtherServiceBasic: {  //esempio di una api con Basic Auth
    importPath: "Api/Services/",
    authConfig: { strategy: "basicAuth", username: "basicUsername", password: "12345-abcde-passw"}, 
    methods: {
      fetchData: {
        clientMethod: "fetchDataUsingGET",
        params: [],
      },
    },
  },
  OtherServiceWithoutAuthentication: {  //esempio di una api senza Autenticazione
    importPath: "Api/Services/",
    authConfig: { strategy: "none"}, 
    methods: {
      fetchData: {
        clientMethod: "fetchDataUsingGET",
        params: [],
      },
    },
  },
};